"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cosmos_1 = require("components/cosmos");
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const mapStateToProps = (stores) => ({
    isFormValid: stores.DrippingFormStore.isValid
});
function DrippingFormFooter({ handleClose, handleSave, isFormValid, saveButtonTitle }) {
    const { t } = (0, translationContext_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cosmos_1.Button, { variation: "tertiary", onClick: handleClose, children: t('general.cancel') }), (0, jsx_runtime_1.jsx)(cosmos_1.Button, { variation: "primary", className: "_ml-4", onClick: handleSave, disabled: !isFormValid, children: saveButtonTitle })] }));
}
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingFormFooter);
